import { Layout,notification,Typography} from "antd";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import UsuariosContext from "../contexts/UsuariosContext";
import PerfilAuth from "./PerfilAuth";

const StyledLayout = styled(Layout)`
height:100%;
`

const StyledBody = styled(Layout)`
width:100%;
`;

const StyledContent = styled.div`
padding:2rem;
max-width: 1300px;
width: 90%;
margin-left: auto;
margin-right: auto;
padding-top: 4rem;
`;



interface MainLayoutProps {
    children:React.ReactNode,
    title?:string,
    maxContentWidth?:number
}

export default (props:MainLayoutProps) => {

    const context = useContext(UsuariosContext);

    useEffect(() => {
        const isTokenValid = context.checkAuth();
        if (!isTokenValid) {
            notification.info({
                message: 'Su sesion ha expirado (30 dias). Por favor, inicie sesion nuevamente...',
                duration: 5,
                placement: 'bottomRight'
            })
            setTimeout(() => context.signOut(),5000);
        }
    }, []);

    return (
        <StyledLayout>
            <StyledBody>
                <StyledContent>
                    <PerfilAuth mode="inline" />
                    {props.title && <Typography.Title level={3}>{props.title}</Typography.Title>}
                    {props.children}
                </StyledContent>
            </StyledBody>
        </StyledLayout>
    );
};

//<div style={{maxWidth:props.maxContentWidth ?? 1024,margin:'auto'}}></div>